import React, {
  useContext,
  useEffect,
} from 'react';
import { SwatchTileGroup, SwatchTile } from 'anf-core-react';
import ProductPageContext from '../../contexts/ProductPageContext';
import BrowserContext from '../../contexts/BrowserContext';
import UrgencyMessage from '../UrgencyMessage/UrgencyMessage';
import AnalyticsTriggers from '../../analytics/analyticsTriggers';
import SocialProofing from '../../features/SocialProofing/SocialProofing';
import SocialProofingUkEu from '../../features/SocialProofing/SocialProofingUKEU';
import SwitchTestContext from '../../contexts/SwitchTestContext';

export default function SwatchGroup({ attrChangeHandler, siteRegion }) {
  const ProductPageState = useContext(ProductPageContext);
  const isBrowser = useContext(BrowserContext);
  const swatchClickedRef = React.useRef(false);
  const SwitchTestState = useContext(SwitchTestContext);
  const hasPdpNewSwatchClickAnalytics = SwitchTestState['pdp-use-new-swatch-click-analytics'];

  const handleSwatchChange = (event, product) => {
    const swatchChangedEvent = new CustomEvent('mfe:SwatchSelected', { detail: product });
    if (isBrowser) window.dispatchEvent(swatchChangedEvent);
    attrChangeHandler(event);

    swatchClickedRef.current = true;

    if (!hasPDPMFEBelowTheFold) {
      window.digitalData.trigger('mfe-pdp-swatch-clicked');
    }
  };

  const { tmntData, collectionData, type } = ProductPageState;
  const { hasPDPMFEBelowTheFold } = collectionData;

  useEffect(() => {
    if (swatchClickedRef?.current && ProductPageState.collectionData.activeProduct.kicId) {
      AnalyticsTriggers.swatchClick(ProductPageState, hasPdpNewSwatchClickAnalytics);
      window.digitalData.set('pdp.suggestedSearch', ProductPageState.collectionData.activeProduct.suggestedSearchAttributes);
      swatchClickedRef.current = false;
    }
  }, [ProductPageState, hasPdpNewSwatchClickAnalytics, ProductPageState.collectionData.activeProduct.kicId]);

  const swatches = collectionData.products.map((product) => {
    const {
      swatchName, swatchImageUrl, kicId, productId, selected, available,
    } = product;

    return (
      <section key={kicId}>
        <SwatchTile
          hasUnavailableStyle={!available}
          label=""
          id={`radio_swatch_${kicId}_${productId}`}
          isChecked={selected}
          onChange={(event) => handleSwatchChange(event, product)}
          alt={swatchName}
          src={swatchImageUrl}
          name="swatch"
          type="radio"
          value={productId}
        />
      </section>
    );
  });
  const isUkEu = siteRegion === 'UK' || siteRegion === 'EU';
  const SocialProofingComponent = isUkEu ? SocialProofingUkEu : SocialProofing;

  return (
    <section data-testid="swatch-group">
      <SwatchTileGroup
        legend={(
          <span className="screen-reader-text">
            {tmntData?.swatchGroupLegend?.value}
          </span>
        )}
      >
        {swatches}
      </SwatchTileGroup>
      <UrgencyMessage
        urgencyMessage={tmntData?.swatchUrgencyMessage?.value}
        showUrgencyMessage={collectionData.showUrgencyMessage}
        rerenderKey={collectionData.activeProduct.productId}
      />

      {type !== 'exchange' ? <SocialProofingComponent /> : null}
    </section>
  );
}
